import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'

// The board is a public, read-only, unattended display: no token, no refresh, no
// toasts. Every read here is a background poll — a failure keeps the last good
// catalog on the wall (useLiveCatalog) and is never drawn over the menu, so this
// client deliberately has no error link at all. `errorPolicy: 'all'` lets a partial
// result through instead of throwing the whole screen away.

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000/graphql'

export const apolloClient = new ApolloClient({
  link: createHttpLink({ uri: API_URL }),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          publicProducts: { merge: (_existing = [], incoming) => incoming, keyArgs: ['category_id'] },
          publicCategories: { merge: (_existing = [], incoming) => incoming, keyArgs: ['filters'] },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: { errorPolicy: 'all' },
    query: { errorPolicy: 'all' },
  },
})
